import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { OrderStatusCheckboxProps } from '../types';
import { NotificationOrderStatusCheckbox } from '../notification-orderStatus-checkbox';

export const OrderStatusCheckboxList: FC<OrderStatusCheckboxProps> = ({
  orderStatusList,
  handlecheckbox,
  orderStatusValue
}) => {
  return (
    <>
      {Object.keys(orderStatusList).map((title) => {
        return (
          <div key={title}>
            <CatHeading
              variant="title-sm"
              level="h6"
              data-testid="notification-preference-heading-md"
            >
              {title}
            </CatHeading>
            <div className="mt-2 ms-2">
              {orderStatusList[title].map((row) => {
                return (
                  <div key={row.label}>
                    <NotificationOrderStatusCheckbox
                      label={row.label}
                      handleChange={handlecheckbox}
                      value={row}
                      orderStatusValue={orderStatusValue}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};
